
import { api_host, token } from '../common/constants'
//console.log('safd')
export const ObjectiveConfig = (objective) =>
//console.log(api_host+`/reporte/especial/getObjetiveConfigurationDashboard/?user=1&token=${token}&objetivoId=${objective}`)
        fetch(api_host+`/reporte/especial/getObjetiveConfigurationDashboard/?user=1&token=${token}&objetivoId=${objective}`)
        .then(response => response.json())
